import { FC, useEffect, useState } from 'react';

import { Alert, AlertTitle, Box, BoxProps } from '@mui/material';

import { useExtension } from '~/hooks/useExtension';

export const SafariAlert: FC<BoxProps> = (props) => {
  const { isInstalled, loading } = useExtension({
    pollForConnection: true,
    pollTimeout: 1000,
    attemptPollAmount: 100000,
  });
  const [messageShown, setMessageShown] = useState<boolean>(false);

  useEffect(() => {
    if (!loading && !isInstalled) {
      setMessageShown(true);
    }
    // Reload page on connection
    if (!loading && isInstalled && messageShown) {
      window.location.reload();
    }
  }, [loading, isInstalled, messageShown]);

  if (isInstalled) {
    return null;
  }

  return (
    <Box {...props}>
      <Alert severity="error">
        <AlertTitle>Toucan Doctor needs permissions</AlertTitle>
        Please grant the <strong>Toucan Extension</strong> permission to this site by clicking the Toucan icon on your
        browser. If you denied access to this site in the past you may need to update this in Safari&apos;s Extension
        Preferances
      </Alert>
    </Box>
  );
};
